import { useEffect } from 'react';
import { useRouter } from 'next/router';

export const useNotFound = (notFoundFlag: boolean) => {
  const router = useRouter();

  useEffect(() => {
    if (notFoundFlag) {
      router.push('/404');
    }
  }, [notFoundFlag, router]);
};
